export class FileTooLargeError extends Error {}
